import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

interface LoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: number;
  text?: string;
  fullScreen?: boolean;
}

export function Loader({ 
  size = 24, 
  text = "Loading...", 
  fullScreen = false, 
  className, 
  ...props 
}: LoaderProps) {
  return (
    <div 
      className={cn(
        "flex flex-col items-center justify-center gap-2",
        fullScreen && "fixed inset-0 z-50 bg-background/80 backdrop-blur-sm",
        className
      )} 
      {...props}
    >
      <Loader2 className="animate-spin" size={size} />
      {text && <p className="text-sm text-muted-foreground">{text}</p>}
    </div>
  );
} 